<template>
  <v-container v-if="user" fluid>
    <v-card class="pa-3">
      <v-card-title class="text-center teal lighten-3 accent-4 white--text">
        Odoo Mostrador
        <v-spacer />
        <v-btn :loading="loading" small @click="getOrdenesOdoo"
          >Actualizar <v-icon small>mdi-refresh</v-icon></v-btn
        >
        <v-spacer />
        <v-checkbox v-model="filtroSurtidos" label="Mostrar surtidos" />
        <v-spacer />
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Búsqueda"
          single-line
          hide-details
          clearable
          class="mb-4"
        ></v-text-field>
      </v-card-title>
      <h4 class="mb-3 mt-3 text-center">
        Total de Ordenes: {{ filteredItems.length }}
      </h4>

      <v-card
        v-for="orden in filteredItems"
        :key="orden.id_orden"
        class="pa-3 mb-3"
        elevation="5"
        :search="search"
      >
        <div class="loading-overlay" v-if="loadingOrdenes">
          <v-progress-circular indeterminate size="70" />
        </div>
        <v-card-title class="text-center teal lighten-1 white--text mb-3">
          {{ orden.name }}
        </v-card-title>

        <!-- Encabezados -->
        <v-row class="font-weight-bold pa-2">
          <v-col cols="3"> Codigo </v-col>

          <v-col cols="5"> Producto </v-col>

          <v-col cols="2"> Cantidad </v-col>

          <v-col cols="2"> Surtido </v-col>
        </v-row>

        <!-- Productos -->
        <v-row
          v-for="producto in orden.productos"
          :key="producto.id_linea"
          class="pa-2 align-center"
          :class="{ 'green lighten-4': producto.surtido }"
        >
          <v-col cols="3">
            {{ producto.codigo_producto }}
          </v-col>
          <v-col cols="5">
            {{ producto.nombre_producto }}
          </v-col>

          <v-col cols="2">
            {{ producto.cantidad }}
          </v-col>

          <v-col cols="2">
            <v-checkbox
              v-model="producto.surtido"
              @change="guardarSurtidos"
              hide-details
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-card>
    </v-card>
  </v-container>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  components: {},

  data() {
    return {
      search: "",
      items: [],
      storageKey: "productos_surtidos", // Clave para localStorage
      loading: false,
      loadingOrdenes: false,
      filtroSurtidos: false,
    };
  },
  methods: {
    async getOrdenesOdoo() {
      this.loading = true;
      this.loadingOrdenes = true;
      try {
        const ordenesMostrador = await axios.get(
          `/odoo/surtimiento_mostrador?id_session=360`,
        );

        const headers = ordenesMostrador.data.columns;
        const rows = ordenesMostrador.data.data;

        const items = rows.map((row) => {
          let obj = {};
          headers.forEach((header, index) => {
            obj[header] = row[index];
          });
          return obj;
        });

        // Agrupar por id
        const agrupados = Object.values(
          items.reduce((acc, item) => {
            if (!acc[item.id_orden]) {
              acc[item.id_orden] = {
                id_orden: item.id_orden,
                name: item.name,
                productos: [],
              };
            }

            acc[item.id_orden].productos.push({
              id_producto: item.id_producto,
              codigo_producto: item.codigo_producto,
              nombre_producto: item.nombre_producto,
              cantidad: item.cantidad,
              id_linea: item.id_linea,
              surtido: false, // Inicialmente no surtido
            });

            return acc;
          }, {}),
        );

        this.items = agrupados;

        this.cargarSurtidos();
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
        this.loadingOrdenes = false;
      }
    },

    cargarSurtidos() {
      const guardados = JSON.parse(localStorage.getItem(this.storageKey)) || {};

      this.items.forEach((orden) => {
        orden.productos.forEach((producto) => {
          if (guardados[producto.id_linea]) {
            producto.surtido = true;
          }
        });
      });
    },

    guardarSurtidos() {
      let surtidos = {};

      this.items.forEach((orden) => {
        orden.productos.forEach((producto) => {
          if (producto.surtido) {
            surtidos[producto.id_linea] = true;
          }
        });
      });

      localStorage.setItem(this.storageKey, JSON.stringify(surtidos));
    },
  },
  created() {
    this.getOrdenesOdoo();
  },
  computed: {
    ...mapGetters(["user"]),

    filteredItems() {
      return this.items.filter((item) => {
        const busqueda = item.name
          .toLowerCase()
          .includes(this.search.toLowerCase());

        const mostrarSurtidos = item.productos.every(
          (producto) => producto.surtido,
        );

        if (this.filtroSurtidos === false) {
          return busqueda && !mostrarSurtidos;
        }

        if (this.filtroSurtidos === true) {
          return busqueda && mostrarSurtidos;
        }

        return busqueda;
      });
    },
  },
  mounted() {
    setInterval(() => {
      this.getOrdenesOdoo();
    }, 60000); //Actualiza cada 60 segundos
  },
};
</script>

<style>
.loading-overlay {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
</style>
